import * as React from 'react'

import { styled } from '@mui/material/styles'
import CardActionArea from '@mui/material/CardActionArea'
import Stack from '@mui/material/Stack'
import Card from '@mui/material/Card'

import Text from 'components/atomic/atoms/text'
import Image from 'next/image'
import { ToolOverview } from 'types/wiki'
import Routes from 'utils/routes'
import Link from 'next/link'

const StyledCard = styled(Card)`
    height: 100%;
    box-shadow: none;
`

const CardContent = styled('div')`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 1rem;
    justify-content: space-between;
    z-index: 1;
    top: 0;
    left: 0;
    padding: 1rem;
`

interface ToolCardProps {
    item: ToolOverview
}

const ToolCard = React.memo(({ item }: ToolCardProps) => {
    return (
        <Link href={Routes.WikiTool(item.slug)}>
            <a>
                <StyledCard>
                    <CardActionArea sx={{ height: '100%' }}>
                        <CardContent>
                            <Stack direction="row" alignItems="center" height={'100%'} spacing={2}>
                                {item.logo && (
                                    <Image
                                        alt={`${item.title} logo`}
                                        unoptimized
                                        width={40}
                                        height={40}
                                        objectFit="contain"
                                        style={{ opacity: 0.7, flex: 'none' }}
                                        src={item.logo}
                                    />
                                )}
                                <Text fontWeight={'bold'} overflow="ellipsis">
                                    {item.title}
                                </Text>
                            </Stack>
                        </CardContent>
                    </CardActionArea>
                </StyledCard>
            </a>
        </Link>
    )
})

export default ToolCard
